import styled from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const DeleteFileButton = styled.button`
  margin-right: 10px;
  border: none;
  background: transparent;
  color: ${colors.primary};
`;

export const UrlButton = styled.button`
  background: transparent;
  border: none;
`;

export const Container = styled.ul`
  margin-top: 20px;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #444;
    & + li {
      margin-top: 15px;
    }
  }

  ${DeleteFileButton},${UrlButton} {
    margin-top: 0;
  }
`;

export const FileInfo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: min-content auto min-content;
  align-items: center;
  column-gap: ${grid.sm};
`;

export const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  span {
    font-size: 12px;
    color: #999;
    margin-top: 5px;
    button {
      border: 0;
      background: transparent;
      color: ${colors.primary};
      margin-left: 5px;
      cursor: pointer;
    }
  }
`;

export const FileStatus = styled.div`
  display: flex;
  align-items: center;
`;

interface PreviewProps {
  src?: string;
}

export const Preview = styled.div<PreviewProps>`
  width: 36px;
  height: 36px;
  border-radius: 5px;
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  margin-right: 10px;
`;

export const FileName = styled.strong`
  max-width: ${`calc(100% - ${grid.xs})`};
  word-break: break-word;
`;
